export const CUSTOM_ICONS: Record<string, string> = {}
